import * as React from "react";
import gsap from "gsap";
import { useGSAP } from "@gsap/react";

import { HeroBg, Page } from "@/components";
import { getAllPosts } from "@/lib/posts";
import { BlogPost } from "@/types";
import Hero from "./components/hero";
import BlogPosts from "./components/blog-posts";
import { TransitionContext } from "@/contexts/TransitionContext";

export async function getStaticProps() {
  const blogs = await getAllPosts();
  return {
    props: {
      blogs,
    },
  };
}

/**
 * Renders the blogs page
 * Shows a list of all blogs
 */
const Blogs = ({ blogs }: { blogs: BlogPost[] }) => {
  const container = React.useRef<HTMLDivElement>(null);

  const { timeline } = React.useContext(TransitionContext);

  useGSAP(
    () => {
      const targets = gsap.utils.toArray([
        container.current,
        "li",
      ]) as HTMLElement[];
      gsap.fromTo(targets, { opacity: 0 }, { opacity: 1, stagger: 0.1 });
      timeline.add(gsap.to(container.current, { opacity: 0 }));
    },
    { scope: container }
  );

  return (
    <div ref={container}>
      <Page pageTitle="Tarun Sharma • Blogs">
        <HeroBg className="md:-top-[50%]" />
        <div className=" 2xl:max-w-8xl 3xl:max-w-9xl 4xl:max-w-10xl 5xl:max-w-11xl relative mx-auto w-full cursor-default pt-32 sm:max-w-[40rem] md:max-w-[50rem] lg:max-w-[63rem] xl:max-w-[75rem]">
          <div className="noise-overlay xs:!opacity-0 absolute inset-0 !z-0 h-[70%] w-full !opacity-50" />
          <Hero />
          <BlogPosts blogs={blogs} />
        </div>
      </Page>
    </div>
  );
};

export default Blogs;
